import React from 'react';
import { Spin } from 'antd';
import type { FooterReport } from '../types';

/** 单个报告 chip：与 FooterFileChip 布局一致（icon 盒 + 文本 + 删除），
 *  使用 iconfont 原始链接图标，底色区别于文件 chip，且带解析中/失败态。 */
export const FooterReportChip: React.FC<{ report: FooterReport; onRemove: () => void; displayKey?: string }> = ({
  report,
  onRemove,
  displayKey,
}) => {
  const label =
    report.status === 'parsing'
      ? '解析中…'
      : report.status === 'error'
        ? report.name || '解析失败'
        : report.name;
  return (
    <div
      className={`rte-footer-report-chip${report.status === 'error' ? ' rte-footer-report-chip-error' : ''}`}
      data-rte-footer-display-key={displayKey}
    >
      <div className="rte-footer-report-icon">
        {report.status === 'parsing' ? (
          <Spin size="small" />
        ) : (
          <svg className="rte-footer-report-link-icon" aria-hidden="true">
            <use xlinkHref="#icon-lianjie" />
          </svg>
        )}
      </div>
      <div className="rte-footer-report-info">
        <span className="rte-footer-report-name" title={report.status === 'done' ? report.name : report.url}>
          {label}
        </span>
        {report.status === 'done' && report.date ? (
          <span className="rte-footer-report-date">{report.date}</span>
        ) : null}
      </div>
      <span
        className="rte-footer-file-remove"
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
      >
        <i
          className="iconfont icon-guanbi"
          style={{ width: '8px', height: '8px', fontSize: '8px', display: 'flex', alignItems: 'center' }}
        />
      </span>
    </div>
  );
};
